import { AbortControllerManager } from '../abortControllerManager';
import { authClient, publicClient } from '../client';
import {
  IOAuthInitiateResponse,
  TOAuthProvider,
} from '@/types/calendarIntegrations';

class OAuthApi extends AbortControllerManager {
  private readonly OAUTH_URL = '/v2/oauth';

  constructor() {
    super();
  }

  ssoLogin(provider: TOAuthProvider): Promise<IOAuthInitiateResponse> {
    const signal = this.createAbortController(`ssoLogin-${provider}`);
    return publicClient.post(`${this.OAUTH_URL}/${provider}/login`, undefined, {
      signal,
    });
  }

  connectOAuthCalendar(
    provider: TOAuthProvider,
    connectionId?: string,
  ): Promise<IOAuthInitiateResponse> {
    const signal = this.createAbortController(
      `connectOAuth-${connectionId}-${provider}-calendar`,
    );
    const params = connectionId ? { connection_id: connectionId } : {};
    return authClient.post(
      `${this.OAUTH_URL}/${provider}/calendar`,
      undefined,
      {
        signal,
        params,
      },
    );
  }

  deleteOAuthConnection(connectionId: string) {
    const signal = this.createAbortController(
      `deleteOAuthConnection-${connectionId}`,
    );
    return authClient.delete(`${this.OAUTH_URL}/connections/${connectionId}`, {
      signal,
    });
  }
}

export const oauthApi = new OAuthApi();
